module.exports = __webpack_public_path__ + "static/logo-76148d2a15dff2c266e1f9bf32befd89.png";